import React from "react";
import Context from "../../../Context";
import List from "../../Misc/List";
import Searchbox from "../../Misc/Searchbox";
import JournalListItem from "./JournalListItem";

export default class JournalList extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      search: [],
      filters: {
        show: false,
        active: [],
        default: [],
        all: [],
      },
      fields: {
        all: [],
        active: [],
      },
      sortings: [],
    };
  }

  componentDidMount() {
    this.setDefaultFilters();
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.nodeId !== this.props.nodeId ||
      prevProps.mode !== this.props.mode
    ) {
      this.setDefaultFilters();
    }
  }

  setDefaultFilters = async () => {
    this.setState((state) => {
      let filters = state.filters;
      filters.default = [];
      if (this.props.nodeId && this.props.nodeId !== "any") {
        filters.default.push({
          field: "tree",
          compare: "EQL",
          value: this.props.nodeId,
        });
      }

      return filters;
    });
  };

  handleSortings = (sortings) => {
    this.setState({ sortings });
  };

  onSearch = (searchValue) => {
    let search = searchValue
      ? [
          {
            lstr: "(",
            field: "label",
            compare: "IKE",
            value: `%${searchValue}%`,
            rstr: ")",
          },
        ]
      : [];
    this.setState({
      search,
    });
  };

  render() {
    return (
      <>
        <div className="d-flex mb-4">
          <Searchbox onSearch={this.onSearch} />
        </div>
        <List
          listKey="journalList"
          key={this.props.customListKey}
          fulltext={JSON.stringify(this.state.search)}
          search={JSON.stringify(
            this.state.filters.active.concat(this.state.filters.default)
          )}
          sort={JSON.stringify(this.state.sortings)}
          fields={JSON.stringify(this.state.fields.active)}
          limit={150}
          hideSinglePageNav={true}
          keyField="id"
          path="/journal/list"
          blocker={{ spinnerFixed: true, hAuto: true }}
        >
          <JournalListItem
            highlightItem={this.props.itemId}
            nodeId={this.props.nodeId}
            mode={this.props.mode}
            itemMode={this.props.itemMode}
          />
        </List>
      </>
    );
  }
}
